//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngPrivacyPolicy', srsngPrivacyPolicy);

    function srsngPrivacyPolicy($rootScope, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/software-info/privacy-policy/privacy-policy.html',
            scope: {
                // activeTab: ""
            },
            controller: controller
        };

        function controller($scope) {
            // this is intentional override
        }

    }

})();

